"use strict";
var newCtrl = require('picture/controllers/newCtrl');
var bulkCtrl = require('picture/controllers/bulkCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('picture', ['templates', 'lr.upload', 'ngFlash']);
app.controller('newCtrl', ['$scope', '$rootScope', '$http', 'upload', 'Flash', newCtrl]);
app.controller('bulkCtrl', ['$scope', '$rootScope', '$http', 'upload', 'Flash', bulkCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
module.exports = app;
